var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "url(#paint0_linear_3505_1125)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 10.3334L18 13.6667M18 10.3334L14.6667 13.6667M7.06667 10.0001H7.66747C8.03475 10.0001 8.21839 10.0001 8.38857 9.95427C8.53935 9.91371 8.68184 9.84697 8.80953 9.75711C8.95364 9.65568 9.07121 9.51461 9.30634 9.23245L11.0569 7.13172C11.3474 6.78317 11.4926 6.6089 11.6195 6.59076C11.7293 6.57506 11.8398 6.61505 11.9142 6.69744C12 6.79259 12 7.01944 12 7.47315V16.527C12 16.9807 12 17.2075 11.9142 17.3027C11.8398 17.3851 11.7293 17.4251 11.6195 17.4094C11.4926 17.3912 11.3474 17.2169 11.0569 16.8684L9.30634 14.7677C9.07121 14.4855 8.95364 14.3444 8.80953 14.243C8.68184 14.1531 8.53935 14.0864 8.38857 14.0458C8.21839 14.0001 8.03475 14.0001 7.66747 14.0001H7.06667C6.6933 14.0001 6.50661 14.0001 6.36401 13.9274C6.23856 13.8635 6.13658 13.7615 6.07266 13.6361C6 13.4934 6 13.3068 6 12.9334V11.0667C6 10.6934 6 10.5067 6.07266 10.3641C6.13658 10.2386 6.23856 10.1366 6.36401 10.0727C6.50661 10.0001 6.6933 10.0001 7.06667 10.0001Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3505_1125",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E36A13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A53716"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundOff);
export default __webpack_public_path__ + "static/media/soundOff.28907fe5490402de82742527010f3975.svg";
export { ForwardRef as ReactComponent };